<script lang="ts" setup>
import type {Area, Component} from "#magnolia-layer/types/magnolia-types";
import {EditableArea, EditableComponent} from "@magnolia/vue-editor";
import {isComponent} from "#magnolia-layer/types/api";
import AsideRelated from "~/templates/areas/AsideRelated.vue";

const props = defineProps<{
  content: Area & {
    aside?: Area;
  };
}>();

const components = computed(() => {
  return props.content
    ? props.content["@nodes"]
        .map((nodeName) => {
          const n = props.content[nodeName];
          if (isComponent(n)) {
            return n;
          }
        })
        .filter((n): n is Component => !!n)
    : [];
});
</script>

<template>
  <template v-for="childContent in components" :key="childContent['@id']">
    <EditableComponent :content="childContent" />
  </template>
  <EditableArea
    v-if="content.aside"
    :content="content.aside"
    :custom-view="AsideRelated"
    class="footer-area col-span-full bg-white border-t-[1px] border-neutral-300 content-grid p-16"
    elementType="footer"></EditableArea>
</template>
<style lang="scss">
// The following functions to make the "New component: Main area" section to be positioned before the related items.
// Take a  high number to the extent that there'll never be any component at that index
$area-order: 999999;
// That's where we position the footer area - at the end (where it would normally already be)
main.content-grid > .footer-area {
  order: #{$area-order};
}
// But as the footer area editorBar exists before the footer element. We have to move it just in-front of the footer area
main.content-grid > div.mgnlEditorBar.area.start {
  order: #{$area-order - 1};
}
// And then as the area end editorBar for the main exists inside the main, but after the footer, we have to position that there.
main.content-grid > div.mgnlEditorBar.area.end {
  order: #{$area-order + 1};
}
</style>
<style lang="scss" scoped></style>
